import md5 from "blueimp-md5"
import Cookies from "js-cookie"

import { appendImagePixel } from "common/services/tracking/bookingUtils"

const PIXEL_ID = "adaraImagePixel"
const BASE_URL = "https://tag.yieldoptimizer.com/ps/ps"
const DATE_FORMAT = "DD-MM-YYYY"
const DEFAULT_PARAMS = {
  t: "i",
  p: 1863,
}

const getHashedEmail = () => {
  const store = window.reduxStore

  if (!store) {
    return ""
  }

  const email = window.reduxStore.state.user.getIn(["user", "email"])

  if (!email) {
    return ""
  }

  return md5(email.trim().toLowerCase())
}

const trackAdaraEvent = event => {
  if (Cookies.get("debug_fakeCuckoo") === "true") return
  const ln = window.SP_GLOBALS.SKYPICKER_LNG
  // email is already set if event is coming from booking page
  const ue = event.ue || getHashedEmail()
  appendImagePixel(PIXEL_ID, BASE_URL, { ...DEFAULT_PARAMS, ...event, ln, ue })
}

export default {
  trackHomePage() {
    trackAdaraEvent({ pg: "hm", crcy: "EUR" })
  },

  /**
   * Tracks data from opened search details
   * @param {*} journey
   */
  trackSearch(journey) {
    const adaraEvent = {
      pg: "sfp",
      saoc: journey.getDeparture().getIn(["where", "code"]),
      sdac: journey.getArrival().getIn(["where", "code"]),
      sdpdt:
        journey
          .getDeparture()
          .getIn(["when", "utc"])
          .format(DATE_FORMAT) || "",
      srdt: journey.isReturn()
        ? journey
            .getInboundTrip()
            .getDeparture()
            .getIn(["when", "utc"])
            .format(DATE_FORMAT)
        : "",
    }
    trackAdaraEvent(adaraEvent)
  },

  /**
   * Tracking of opened booking
   */
  trackSelectedResultsPage(journey, totalPrice) {
    const adaraEvent = {
      pg: "srp",
      slaf: totalPrice,
      sloac: journey.getDeparture().getIn(["where", "code"]),
      sldac: journey.getArrival().getIn(["where", "code"]),
      sldpt:
        journey
          .getDeparture()
          .getIn(["when", "utc"])
          .format(DATE_FORMAT) || "",
      slrdt: journey.isReturn()
        ? journey
            .getInboundTrip()
            .getDeparture()
            .getIn(["when", "utc"])
            .format(DATE_FORMAT)
        : "",
    }

    trackAdaraEvent(adaraEvent)
  },

  /**
   * Tracking of finished booking
   */
  trackFlightBookingPage(args) {
    // email is explicitly entered on booking page
    const ue = md5(
      String(args.ue)
        .trim()
        .toLowerCase(),
    )

    trackAdaraEvent({ ...args, ue, pg: "bfp" })
  },
}
